(ns practitest.frontend.components2.dashboard.charts.line
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.charts.render-helpers :as rh]
            [practitest.frontend.components2.dashboard.transforms.line :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(defn base-spec [chart]
  (let [toggle-evt    #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])
        palette       (:chart/colors-palette chart)
        series-labels (:chart/series chart)
        ordered-range (mapv (fn [label] (get palette label)) series-labels)
        legend?       (not= :no-legend (:chart/legend-location chart))]
    {:mark    :line
     :padding {:top 5 :right 20 :bottom 25 :left 35}
     :tooltip true
     :point   true
     :data    (:chart/data chart)
     :caption (when-let [text (:chart/caption chart)] {:text (str "*" text)
                                                       :offset 70})
     :encode  {:x       {:field :date
                         :type  :temporal
                         :scale {:type   :point
                                 :domain (:chart/categories chart)}
                         :axis  {:label-angle  -40
                                 :format       "%Y-%m-%d"
                                 :values       (:chart/categories chart)
                                 :ticks        (when (empty? (:chart/data chart)) false)
                                 :label-stride (:chart/x-label-visible-step chart)}}
               :y       {:field :value
                         :type  :quantitative
                         :axis  {:grid true}}
               :tooltip {:mode :category-group
                         :sort :desc}
               :color   (cond-> {:field :group
                                 :type  :nominal
                                 :scale {:domain series-labels
                                         :range  ordered-range}}
                          legend?
                          (assoc :legend {:opacity {:one-of (:chart/inactive-groups chart)}
                                          :offset 70}))}
     :on-legend-click toggle-evt}))

(defmethod p/render! ::chart/line [chart _ctx svg-element]
  (r/render-chart! svg-element (base-spec chart)))

(defmethod p/transform-data ::chart/line [chart]
  (transforms/transform chart))
